import { CALL_API } from "admin/middlewares/api";
import { encodeQueryData } from "../../../utilities/browser.tools";
import moment from "moment";

export const ACCOUNT_BALANCE_FETCH_REQUEST = "ACCOUNT_BALANCE_FETCH_REQUEST";
export const ACCOUNT_BALANCE_FETCH_SUCCESS = "ACCOUNT_BALANCE_FETCH_SUCCESS";
export const ACCOUNT_BALANCE_FETCH_ERROR = "ACCOUNT_BALANCE_FETCH_ERROR";

export const TRUSTLY_ACCOUNT_BALANCE_FETCH_REQUEST =
  "TRUSTLY_ACCOUNT_BALANCE_FETCH_REQUEST";
export const TRUSTLY_ACCOUNT_BALANCE_FETCH_SUCCESS =
  "TRUSTLY_ACCOUNT_BALANCE_FETCH_SUCCESS";
export const TRUSTLY_ACCOUNT_BALANCE_FETCH_ERROR =
  "TRUSTLY_ACCOUNT_BALANCE_FETCH_ERROR";

export const LS_ACCOUNT_BALANCE_FETCH_REQUEST =
  "LS_ACCOUNT_BALANCE_FETCH_REQUEST";
export const LS_ACCOUNT_BALANCE_FETCH_SUCCESS =
  "LS_ACCOUNT_BALANCE_FETCH_SUCCESS";
export const LS_ACCOUNT_BALANCE_FETCH_ERROR = "LS_ACCOUNT_BALANCE_FETCH_ERROR";

export const ORIGINATORS_BALANCE_FETCH_REQUEST =
  "ORIGINATORS_BALANCE_FETCH_REQUEST";
export const ORIGINATORS_BALANCE_FETCH_SUCCESS =
  "ORIGINATORS_BALANCE_FETCH_SUCCESS";
export const ORIGINATORS_BALANCE_FETCH_ERROR =
  "ORIGINATORS_BALANCE_FETCH_ERROR";

// This should fetch only one object of TotalAccountBalance so we can assign it in our reducer
// either creating a new entry or updating an existing one
export function fetch_account_balance_for_day(date, currency) {
  const params = encodeQueryData({ ForDate: date, Currency: currency });
  return {
    [CALL_API]: {
      endpoint: "/api/admin/balances" + params,
      method: "GET",
      authenticatedRequest: true,
      additionalData: { Currency: currency },
      types: [
        ACCOUNT_BALANCE_FETCH_REQUEST,
        ACCOUNT_BALANCE_FETCH_SUCCESS,
        ACCOUNT_BALANCE_FETCH_ERROR,
      ],
    },
  };
}

export function fetch_trustly_account_balance(currency) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/trustly-balances",
      method: "GET",
      authenticatedRequest: true,
      additionalData: { Currency: currency },
      types: [
        TRUSTLY_ACCOUNT_BALANCE_FETCH_REQUEST,
        TRUSTLY_ACCOUNT_BALANCE_FETCH_SUCCESS,
        TRUSTLY_ACCOUNT_BALANCE_FETCH_ERROR,
      ],
    },
  };
}

export function fetch_ls_account_balances(date, currency) {
  const params = encodeQueryData({ ForDate: date, Currency: currency });
  return {
    [CALL_API]: {
      endpoint: "/api/admin/loanstep/balances" + params,
      method: "GET",
      authenticatedRequest: true,
      additionalData: { Currency: currency },
      types: [
        LS_ACCOUNT_BALANCE_FETCH_REQUEST,
        LS_ACCOUNT_BALANCE_FETCH_SUCCESS,
        LS_ACCOUNT_BALANCE_FETCH_ERROR,
      ],
    },
  };
}

export function fetch_originator_balances(date, currency) {
  const params = encodeQueryData({ ForDate: date, Currency: currency });
  return {
    [CALL_API]: {
      endpoint: "/api/admin/originator-balances" + params,
      method: "GET",
      authenticatedRequest: true,
      additionalData: { Currency: currency },
      types: [
        ORIGINATORS_BALANCE_FETCH_REQUEST,
        ORIGINATORS_BALANCE_FETCH_SUCCESS,
        ORIGINATORS_BALANCE_FETCH_ERROR,
      ],
    },
  };
}

// This should fetch a collection of TotalAccountBalance objects, similar to the previous call it would
// either create new entries or update existing ones
export function fetch_account_balance_for_time_span(from, to, currency) {
  from = moment(from).format("YYYY-MM-DD");
  to = moment(to).format("YYYY-MM-DD");
  const params = encodeQueryData({ From: from, To: to, Currency: currency });

  return {
    [CALL_API]: {
      endpoint: `/api/admin/balances/dayrange${params}`,
      method: "GET",
      authenticatedRequest: true,
      additionalData: { Currency: currency },
      types: [
        ACCOUNT_BALANCE_FETCH_REQUEST,
        { method: fetch_todays_account_balance.bind(this, currency) },
        ACCOUNT_BALANCE_FETCH_ERROR,
      ],
    },
  };
}

function fetch_todays_account_balance(currency, response) {
  return (dispatch) => {
    dispatch({
      type: ACCOUNT_BALANCE_FETCH_SUCCESS,
      timespanFetch: true,
      response,
    });

    const today = new Date();
    dispatch(fetch_account_balance_for_day(today, currency));
  };
}

export const ACCOUNT_BALANCE_CHANGE_DATE = "ACCOUNT_BALANCE_CHANGE_DATE";

// DateType == "From" || "To" || "Selected"
export function change_date(dateType, date) {
  return {
    type: ACCOUNT_BALANCE_CHANGE_DATE,
    dateType,
    date,
  };
}
